import { Stack, styled } from '@mui/material'
import { CARD_HEIGHT } from '../constants'

export const CardContainer = styled(Stack, {
  slot: 'CardContainer',
})(
  ({
    theme: {
      spacing,
      vars: { palette },
    },
  }) => ({
    height: CARD_HEIGHT,
    paddingInline: spacing(10),
    paddingBlock: spacing(5),
    gap: spacing(1),
    alignItems: 'center',
    justifyContent: 'center',

    '& > *': {
      textAlign: 'center',
      color: palette.text.secondary,
    },
  }),
)
